// src/features/release-notes/i18n/es.ts

export default {
  name: 'Novedades',
  title: 'Novedades',
  subtitle: 'Los cambios recientes de la aplicación que pueden afectarle, de más nuevo a más antiguo.',
  empty: 'Todavía no hay novedades que mostrar.',
  new: 'Nueva',
  gotIt: 'Entendido',
  close: 'Cerrar',
  openScreen: 'Ir a la pantalla',
  openManual: 'Ver en el manual',
  kind: {
    action: 'Requiere su atención',
    guests: 'Para sus huéspedes',
    feature: 'Novedad',
  },
  dialog: {
    title: 'Novedades',
    intro: 'Estos cambios recientes pueden afectar a su trabajo diario.',
  },
};
